import { FC, useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { distanceOfPointsStepQueryState } from "../../stores";
import { useDistanceOfPointsStepQuery } from "../../generated/graphql";
import { useParams } from "react-router-dom";


export const LoadDistanceStep: FC = () => {
    useLoadDistanceStep()
    return null;
};

function useLoadDistanceStep() {
    const { group, from } = useParams();
    const setValue = useSetRecoilState(distanceOfPointsStepQueryState);
    const { data, loading } = useDistanceOfPointsStepQuery({
        skip: !group || !from,
        variables: { id: group, from },
    });
    useEffect(() => {
        setValue({ data, loading });
    }, [data, loading, setValue]);
    return null;
};
